import React from 'react';

const Button = (props) => {
  const buttonColor = props.light ? 'light' : 'default';
  const ignorePaddingMargin = props.ignorePaddingMargin ? '' : 'no-padding-margin';
  const fullWidth = props.fullWidth ? 'full-width' : '';
  const additional = props.id ? { id: props.id } : {};
  return (
    <button // eslint-disable-line react/button-has-type
      className={`generic-button ${buttonColor} ${props.classContent} ${ignorePaddingMargin} ${fullWidth}`}
      onClick={props.onClick}
      title={props.title}
      type={props.buttonType}
      aria-label={props.ariaLabel}
      {...additional}
    >
      {props.children}
    </button>
  );
};

Button.defaultProps = {
  onClick: () => { },
  classContent: '',
  title: '',
  children: null,
  ariaLabel: '',
  light: false,
  ignorePaddingMargin: false,
  fullWidth: false,
  buttonType: 'button',
};

export default Button;
